import styled, { DefaultTheme, keyframes } from 'styled-components';

const growChip = keyframes`
  0% {
    transform: scale(0)
  }
  60% {
    transform: scale(1.1)
  }
  100% {
    transform: scale(1)
  }
`;

export const ListName = styled.span`
  font-size: 15px;
  text-align: left;
  align-self: center;
  margin-left: 10px;
`;

export const SuggestionsListItem = styled.div<{ $isThere: boolean; $selected: boolean }>`
  cursor: pointer;
  background-color: ${({ $isThere, $selected, theme }) =>
    $isThere ? ($selected ? theme.black.a1 : theme.black.a0) : $selected ? theme.baseBlue.a10 : theme.white.a10};
  color: ${({ $selected, $isThere, theme }) => ($selected && !$isThere ? theme.white.a10 : theme.baseBlue.a8)};
  display: flex;
  padding: 0.834rem;
  &:hover {
    background-image: ${({ $isThere, theme }) =>
      $isThere ? 'none' : `linear-gradient(280deg, ${theme.baseBlue.a8}, ${theme.baseBlue.a10})`};
    ${ListName} {
      color: ${({ $isThere, theme }) => ($isThere ? theme.baseBlue.a8 : theme.white.a10)};
    }
  }
`;

export const CloseIcon = styled.span`
  cursor: pointer;
  height: 22px;
  display: flex;
  align-items: center;
  padding-left: 5px;
  padding-right: 4px;
  margin-left: 0 !important;
  margin-right: -5px;
`;

export const CustomChipContainer = styled.div<{ $locked?: boolean }>`
  padding: 5px 10px 5px 5px;
  margin: 5px;
  text-transform: uppercase;
  display: flex;
  border-radius: 50px;
  background-color: ${({ theme }) => theme.black.a1};
  font-size: 12px;
  font-weight: 600;
  line-height: 2.17;
  letter-spacing: 0.2px;
  align-items: center;
  color: ${({ theme }) => theme.baseBlue.a8};
  animation: ${growChip} 250ms cubic-bezier(0.32, 0.62, 0.2, 0.88);
  position: relative;
  &::after {
    pointer-events: none;
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50px;
    background-color: black;
    opacity: 0.1;
    margin-left: -5px;
    display: none;
  }
  > span {
    margin-left: 10px;
  }
  &:hover {
    &::after {
      display: ${({ $locked }) => ($locked ? 'none' : 'block')};
    }
  }
`;

function getChipsBorderColor(
  error: boolean | string | undefined,
  locked: boolean | undefined,
  isFocused: boolean | undefined,
  blank: boolean | undefined,
  theme: DefaultTheme,
) {
  if (locked || blank) {
    return 'transparent';
  }
  if (error) {
    return theme.red.a10;
  }
  if (isFocused) {
    return theme.baseBlue.a10;
  }
  return theme.baseBlue.a3;
}

export const ChipsContainer = styled.div<{
  $error: boolean | string | undefined;
  $locked?: boolean;
  $isFocused?: boolean;
  $blank?: boolean;
}>`
  background-color: ${({ $error, theme, $locked }) =>
    $locked ? 'transparent' : $error ? theme.red.a1 : theme.white.a10};
  border-radius: 5px;
  border: 1px solid
    ${({ $error, theme, $locked, $isFocused, $blank }) =>
      getChipsBorderColor($error, $locked, $isFocused, $blank, theme)};
`;
